import { render, staticRenderFns } from "./registrations-trend-card.vue?vue&type=template&id=7ec0b0be&scoped=true&"
import script from "./registrations-trend-card.vue?vue&type=script&lang=js&"
export * from "./registrations-trend-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec0b0be",
  null
  
)

export default component.exports